import React from 'react';
import { connect } from 'react-redux';
import { unstable_HistoryRouter as Router, Routes, Route } from 'react-router-dom';
import { CheckLogin } from './Services/Actions';

import history from '../src/history';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import Dashboard from './Pages/Dashboard';
import DHCDetail from './Pages/DHCDetail';
import Login from './Pages/Login';
import Logout from './Pages/Logout';

import PageWithDrawer from './Components/PageWithDrawer';

const IGNORE_PATHS = [ '/logout' ];

class App extends React.Component {
    state = {
        CurrentPathname: window.location.pathname
    }

    componentDidMount() {
        if (IGNORE_PATHS.indexOf(window.location.pathname) === -1) {
            this.props.CheckLogin().then(() => {
                // Set Router To Watch Changes
                    this.unlisten = history.listen(({ location }) => {
                        this.onUpdateCurrentLocation(location.pathname);
                    });
            })
        }
    }

    onUpdateCurrentLocation = CurrentPathname => {
        this.setState({ CurrentPathname });
    }

    render() {
        var { IsLoggedIn } = this.props;

        return (
            <>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Router history={history}>
                        {
                            !IsLoggedIn ?
                            <Routes>
                                <Route path="/login" exact element={<Login />} />

                                <Route path="/logout" exact element={<Logout />} />
                            </Routes>
                        :
                            <PageWithDrawer CurrentPathname={this.state.CurrentPathname}>
                                <Routes>
                                    <Route path="/dashboard" exact element={<Dashboard />} />
                                    <Route path="/dhc/:DHCId" exact element={<DHCDetail />} />

                                    <Route path="/logout" exact element={<Logout />} />
                                </Routes>
                            </PageWithDrawer>
                        }
                    </Router>
                </LocalizationProvider>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        IsLoggedIn: state.Auth.IsLoggedIn,
        UserDetails: state.Auth.UserDetails,

        TryingLoginUser: state.Auth.TryingLoginUser,
        TryingLoginUserError: state.Auth.TryingLoginUserError
    };
}

export default connect(mapStateToProps, { CheckLogin })(App);